import React from 'react';
import { EXPERT_APP_DOMAIN } from '../lib/utils';

export const APP_SUBDOMAIN_TAKEN_MESSAGE = 'This address is already in use. Choose another.';

interface TenantProductsFieldProps {
  clientAdminEnabled: boolean;
  domainExpertEnabled: boolean;
  onClientAdminChange: (checked: boolean) => void;
  onDomainExpertChange: (checked: boolean) => void;
  appSubdomain: string;
  onAppSubdomainChange?: (value: string) => void;
  appSubdomainError?: string | null;
  appSubdomainHint?: string;
  disabled?: boolean;
}

const checkboxClass = 'h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 disabled:opacity-50';

const TenantProductsField: React.FC<TenantProductsFieldProps> = ({
  clientAdminEnabled,
  domainExpertEnabled,
  onClientAdminChange,
  onDomainExpertChange,
  appSubdomain,
  onAppSubdomainChange,
  appSubdomainError,
  appSubdomainHint,
  disabled = false,
}) => {
  const appSubdomainEditable = !!onAppSubdomainChange && !disabled;

  return (
    <div>
      <span className="block text-sm font-medium text-gray-700">Available products</span>
      <div className="mt-2 space-y-2">
        <label className="flex items-center gap-2 text-sm text-gray-700">
          <input
            type="checkbox"
            className={checkboxClass}
            checked={clientAdminEnabled}
            onChange={(e) => onClientAdminChange(e.target.checked)}
            disabled={disabled || (clientAdminEnabled && !domainExpertEnabled)}
          />
          Client Admin
        </label>
        <label className="flex items-center gap-2 text-sm text-gray-700">
          <input
            type="checkbox"
            className={checkboxClass}
            checked={domainExpertEnabled}
            onChange={(e) => onDomainExpertChange(e.target.checked)}
            disabled={disabled || (domainExpertEnabled && !clientAdminEnabled)}
          />
          Domain Expert Agents
        </label>
      </div>
      <p className="mt-1 text-xs text-gray-500">At least one product must stay selected.</p>

      {domainExpertEnabled && (
        <div className="mt-3">
          <label htmlFor="app-subdomain" className="block text-sm font-medium text-gray-700">
            Expert app address
          </label>
          <div className="mt-1 flex rounded-md shadow-sm">
            <input
              id="app-subdomain"
              type="text"
              value={appSubdomain}
              onChange={(e) => onAppSubdomainChange?.(e.target.value.toLowerCase().replace(/\s+/g, ''))}
              readOnly={!appSubdomainEditable}
              disabled={!appSubdomainEditable}
              className={`block w-full min-w-0 flex-1 rounded-none rounded-l-md border px-3 py-2 sm:text-sm focus:outline-none ${
                appSubdomainError ? 'border-red-400 focus:border-red-500' : 'border-gray-300 focus:border-gray-400'
              } ${appSubdomainEditable ? '' : 'bg-gray-50'}`}
            />
            <span className="inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 text-sm text-gray-500">
              .{EXPERT_APP_DOMAIN}
            </span>
          </div>
          {appSubdomainError ? (
            <p className="mt-1 text-xs text-red-600">{appSubdomainError}</p>
          ) : (
            appSubdomainHint && <p className="mt-1 text-xs text-gray-500">{appSubdomainHint}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default TenantProductsField;
